import React, { useState } from "react";
import {
    Box,
    Paper,
    TextField,
    Button,
    Typography,
    Collapse,
    IconButton,
} from "@mui/material";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import CloseIcon from "@mui/icons-material/Close";

const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const SwitchUser = ({ currentEmail, hasPermission, onSwitch }) => {
    const [open, setOpen] = useState(false);
    const [newEmail, setNewEmail] = useState("");
    const [error, setError] = useState("");

    if (!hasPermission) {
        return (
            <Paper
                elevation={1}
                sx={{
                    p: 2,
                    mb: 3,
                    backgroundColor: "#f9f9f9",
                    borderRadius: 2,
                }}
            >
                <Typography variant="body1">
                    <strong>User:</strong> {currentEmail}
                </Typography>
            </Paper>
        );
    }

    const handleEmailChange = (value) => {
        setNewEmail(value);

        if (!value) {
            setError("");
            return;
        }

        if (!isValidEmail(value)) {
            setError("Please enter a valid email address.");
        } else {
            setError("");
        }
    };

    const handleApply = () => {
        if (!isValidEmail(newEmail)) {
            setError("Please enter a valid email address.");
            return;
        }

        onSwitch(newEmail.trim());
        setNewEmail("");
        setError("");
        setOpen(false);
    };

    return (
        <Paper
            elevation={2}
            sx={{
                p: 2,
                mb: 3,
                borderRadius: 2,
                backgroundColor: "#f7faff",
                border: "1px solid #d4e2ff",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="body1">
                    <strong>User:</strong> {currentEmail}
                </Typography>

                {!open && (
                    <Button
                        variant="contained"
                        size="small"
                        startIcon={<ManageAccountsIcon />}
                        onClick={() => setOpen(true)}
                        sx={{ textTransform: "none", borderRadius: 2 }}
                    >
                        Switch User
                    </Button>
                )}

                {open && (
                    <IconButton onClick={() => setOpen(false)}>
                        <CloseIcon />
                    </IconButton>
                )}
            </Box>

            <Collapse in={open}>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Enter a user email to switch to:
                    </Typography>

                    <TextField
                        fullWidth
                        label="User Email"
                        size="small"
                        value={newEmail}
                        onChange={(e) => handleEmailChange(e.target.value)}
                        error={Boolean(error)}
                        helperText={error}
                        sx={{ mb: 2 }}
                    />

                    <Button
                        variant="contained"
                        fullWidth
                        disabled={!newEmail || Boolean(error)}
                        onClick={handleApply}
                        sx={{
                            textTransform: "none",
                            py: 1.2,
                            borderRadius: 2,
                        }}
                    >
                        Apply User
                    </Button>
                </Box>
            </Collapse>
        </Paper>
    );
};

export default SwitchUser;
